export default {
  "hierarchy": {
    "perPage": [
      "textInput-perPage"
    ],
    "formInput": [
      "textInput-formInput"
    ],
    "attributeTableStringEditor": [
      "textInput-attributeTableStringEditor"
    ],
    "password": [
      "textInput-formInput",
      "textInput-password"
    ],
    "inputGrow": [
      "textInput-inputGrow"
    ],
    "multiSelector": [
      "textInput-multiSelector"
    ],
    "small": [
      "textInput-small"
    ],
    "attributeStringEditor": [
      "textInput-attributeStringEditor"
    ],
    "attributeEditor": [
      "textInput-attributeEditor"
    ],
    "comparator": [
      "textInput-comparator"
    ],
    "imageUrlInput": [
      "textInput-inputGrow",
      "textInput-imageUrlInput"
    ],
    "customTextValueEditor": [
      "textInput-customTextValueEditor"
    ],
    "attributeDetailIntEditor": [
      "textInput-attributeTableStringEditor",
      "textInput-attributeDetailIntEditor"
    ],
    "dateRange": [
      "textInput-dateRange"
    ]
  },
  "props": {
    "default": {
      "icon": ""
    },
    "perPage": {
      "icon": ""
    },
    "formInput": {
      "icon": ""
    },
    "attributeTableStringEditor": {
      "icon": ""
    },
    "password": {
      "icon": "",
      "hidePasswordIcon": "fa fa-eye-slash fa-fw",
      "showPasswordIcon": "fa fa-eye fa-fw",
      "showPasswordOptions": {
        "hidePasswordIcon": "",
        "showPasswordIcon": ""
      }
    },
    "inputGrow": {
      "icon": ""
    },
    "multiSelector": {
      "icon": ""
    },
    "small": {
      "icon": ""
    },
    "attributeStringEditor": {
      "icon": ""
    },
    "attributeEditor": {
      "icon": ""
    },
    "comparator": {
      "icon": ""
    },
    "imageUrlInput": {
      "icon": ""
    },
    "customTextValueEditor": {
      "icon": ""
    },
    "attributeDetailIntEditor": {
      "icon": ""
    },
    "dateRange": {
      "icon": ""
    }
  }
}